<ng-container>
	@for (item of items; track item) {
		<div>
			<a class="validation-item" (click)="item.action(); close()" [attr.data-counter]="item.amount">{{item.message}}</a>
		</div>
	}
</ng-container>